import "./Impulse.scss";
import { SubAreaContentByPhase } from "../contentManager/SubAreaContentByPhase";

export const Impulse = () => {
    return <div className="impulse-container">
        <h2>Impulse</h2>
        <SubAreaContentByPhase area="impulse" />
    </div>;
};